<template>
  <CCol col="12" sm="6" md="7" xxl="7">
    <CCard v-if="widgetData === undefined">
      <CCardHeader class="bg-affili-indigo text-white">
        <span class="font-lg" v-if="$policy('store').create">آخرین کانورژن‌ها</span>
        <span class="font-lg" v-else>آخرین خریدها و لیدها</span>
      </CCardHeader>
      <CCardBody class="p-0">
        <div class="table-responsive">
          <table class="table table-sm table-borderless mb-0" style="min-width: 250px">
            <tbody class="">
              <tr class="text-center" :class="i !== 5 ? 'b-b-1' : ''" v-for="i in 5" :key="i">
                <td class="text-right pr-2" style="">
                  <span class="animated-background d-block" style="margin-top: 5px;margin-bottom: 5px;height: 19px;">
                    <span class="d-block background-masker btn-divide-left"></span>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </CCardBody>
    </CCard>
    <CCard v-else>
      <CCardHeader class="bg-affili-indigo text-white">
        <span class="font-lg" v-if="$policy('store').create">آخرین کانورژن‌ها</span>
        <span class="font-lg" v-else>آخرین خریدها و لیدها</span>
      </CCardHeader>
      <CCardBody class="p-0">
        <div v-if="widgetData.length == 0" class="mt-1 mb-3">
          <EmptyBox message="داده‌ای موجود نیست" />
        </div>
        <div v-else class="table-responsive">
          <table class="table table-sm table-borderless mb-0" style="min-width: 350px">
            <tbody>
              <tr class="text-center" :class="index + 1 !== widgetData.length ? 'b-b-1' : ''" v-for="(item, index) in widgetData" :key="index">
                <td class="text-right pr-2">{{ item.user ? item.user.full_name : '-' }}</td>
                <td class="text-left pl-2"><span class="font-weight-bold">{{ item.created_at ? $moment(item.created_at).format('LL') : '-' }}</span></td>
                <td class="text-left pl-2"><span class="font-weight-bold">{{ item.type === ConversionType.SALE ? $commas(item.amount) + ' ' + 'ریال' : '-' }}</span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </CCardBody>
    </CCard>
  </CCol>
</template>

<script>
import { widgetService } from "@/services/api";
import { ConversionType } from "@/constants";

export default {
  name: "LatestConversionsTable",

  data() {
    return {
      ConversionType,
      widgetData: undefined,
    };
  },

  created() {
    widgetService
      .fetch({
        needles: {
          18: { model: 18, config: {} },
        },
      })
      .then((res) => {
        this.widgetData = res.data.data[18].result;
      });
  },
};
</script>